import { default as as } from 'axios';
import { API_URL } from '../constants';

const axios = as.create({
	baseURL: `${ API_URL }/api/v1/client`
});

export default axios;
